/* tslint:disable:jsx-no-lambda WI:47646 */
import { ControlIcons } from 'owa-control-icons';
import { observer } from 'mobx-react';
import { AriaProperties, generateDomPropertiesForAria } from 'owa-accessibility';
import * as React from 'react';
import { ActionButton, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';

const styles = require('./StarCharm.scss');
const classNames = require('classnames/bind').bind(styles);

export interface StarCharmProps {
    isStarred: boolean;
    onClick: (evt: React.MouseEvent<unknown>) => void;
    isClickDisabled?: boolean;
    ariaLabelText?: string;
    tooltip?: { starred: string; unstarred: string };
    animate?: boolean;
    iconStyles?: string;
    buttonStyles?: IButtonStyles;
    spinnerStyles?: string;
}

@observer
export default class StarCharm extends React.Component<StarCharmProps, {}> {
    static defaultProps = {
        tooltip: { starred: '', unstarred: '' },
        iconStyles: styles.starIcon,
    };

    render() {
        const starIcon = this.props.isStarred
            ? ControlIcons.FavoriteStarFill
            : ControlIcons.FavoriteStar;
        const starIconClassNames = classNames(
            this.props.iconStyles,
            styles.starIconBase,
            this.props.animate && this.props.isStarred ? styles.saved : undefined,
            this.props.animate && styles.noTextAnimation
        );

        const tooltip = this.props.isStarred
            ? this.props.tooltip.starred
            : this.props.tooltip.unstarred;

        const ariaProps: AriaProperties = {
            role: undefined, // the button tag comes with an implicit role, this avoids redundancy
            label: this.props.ariaLabelText,
        };

        const buttonClassNames = classNames(
            styles.container,
            this.props.buttonStyles,
            this.props.isClickDisabled && styles.clickDisabled
        );

        return this.props.isClickDisabled ? (
            <div className={this.props.spinnerStyles}>
                <Spinner size={SpinnerSize.small} />
            </div>
        ) : (
            <ActionButton
                className={buttonClassNames}
                checked={this.props.isStarred}
                toggle={true}
                onClick={event => this.props.onClick(event)}
                onDoubleClick={this.onDoubleClick}
                iconProps={{
                    iconName: starIcon,
                    styles: {
                        root: starIconClassNames,
                    },
                }}
                title={tooltip}
                {...generateDomPropertiesForAria(ariaProps)}
            />
        );
    }

    private onDoubleClick = (evt: React.MouseEvent<unknown>) => {
        evt.stopPropagation();
        evt.preventDefault();
    };
}
